
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calculators/mileage-calculator",
      function () {
        return require("private-next-pages/calculators/mileage-calculator/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calculators/mileage-calculator"])
      });
    }
  